import React, {
  memo,
  useState
} from "react";
// eslint-disable-next-line import/no-unresolved
import WaIcon from "images/integrations/wa.png";
import { useTranslation } from "react-i18next";
import CallCustomerData from './CallCustomerData';
import ButtonComponent from "../../components/ButtonMC";
import IconMC from "../../components/IconMC";

const PermissionRequestDialog = memo(({ customer, onClose, onRequestPermission }) => {
  const { t } = useTranslation('Fonema');

  // Estado para mostrar/ocultar la "X" al hacer hover en la esquina superior derecha
  const [isCloseHoverVisible, setIsCloseHoverVisible] = useState(false);

  return (
    <div
      className="tw-wrapper"
      style={{
        right: 8,
        top: 185,
        position: "fixed",
        outline: 'none',
        maxWidth: 360,
        minWidth: 280,
        margin: 0,
        zIndex: 9999
      }}
      tabIndex={-1}
      aria-label={t('outcoming_call')}
    >
      <div className="incoming-call-bar tw-bg-blue-950 tw-text-white tw-select-none tw-p-4 tw-rounded-xl tw-border-transparent tw-relative">
        {/* Zona de hover (esquina superior derecha) para mostrar la "X" */}
        <div
          className="tw-absolute tw-top-1 tw-right-1 tw-w-8 tw-h-8 tw-z-[10000]"
          onMouseEnter={() => setIsCloseHoverVisible(true)}
          onMouseLeave={() => setIsCloseHoverVisible(false)}
        >
          <button
            type="button"
            aria-label="Close"
            onClick={onClose}
            className={[
              "tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-rounded-full",
              "tw-bg-blue-900/60 hover:tw-bg-blue-800/70 tw-text-white",
              "tw-text-[12px] tw-font-bold tw-transition-opacity tw-duration-150",
              isCloseHoverVisible ? "tw-opacity-100 tw-pointer-events-auto" : "tw-opacity-0 tw-pointer-events-none"
            ].join(" ")}
          >
            X
          </button>
        </div>
        <div className="tw-flex tw-flex-row tw-align-middle">
          <img src={WaIcon} alt="WhatsApp" className="tw-w-6 tw-h-6" />
          <span className="tw-ml-1 tw-text-blue-100 tw-text-sm">{t('outcoming_call')}</span>
        </div>
        <CallCustomerData customer={customer} phone={customer?.phone} />
        <div className="tw-w-full tw-mt-2 tw-p-2 tw-bg-blue-50 tw-border tw-border-blue-200 tw-rounded-lg tw-flex tw-items-start tw-gap-2">
          <IconMC name="info-outline" size="base" className="tw-text-blue-500 tw-flex-shrink-0 tw-self-start" />
          <p
            className="tw-m-0 tw-flex-1 tw-self-start tw-text-left tw-text-[10px] tw-text-blue-500 tw-font-medium"
            style={{ lineHeight: 1.15 }}
          >
            {t('permissionInfo')}
          </p>
        </div>
        <div className="tw-text-[10px] tw-text-blue-300 tw-font-normal tw-mt-2">
          {t('messagePreview')}
        </div>

        <div className="tw-max-w-sm">
          <div className="tw-bg-white tw-p-3 tw-rounded-lg tw-shadow-sm">
            <div className="tw-flex tw-items-center tw-gap-2 tw-bg-gray-100 tw-p-2 tw-rounded-lg">
              <div className="tw-bg-white tw-p-1 tw-rounded-full">
                <IconMC name="phone-outline" size="base" className="tw-text-gray-700 tw-flex-shrink-0 tw-mt-0.5" />
              </div>
              <span className="tw-text-sm tw-text-gray-950 tw-font-medium">
                {t('callQuestion')}
              </span>
            </div>

            <div className="tw-mt-3">
              <hr className="tw-border-gray-200" />
              <div className="tw-py-3 tw-flex tw-items-center tw-justify-center tw-text-green-600 tw-text-sm tw-cursor-pointer hover:tw-bg-green-50 tw-transition-colors tw-rounded">
                <span className="tw-font-medium">{t('allowCalls')}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="tw-flex tw-gap-1 tw-mt-2">
          <ButtonComponent
            text={t('requestPermissionText')}
            className="tw-w-full"
            onClick={onRequestPermission}
          />
        </div>
      </div>
    </div>
  );
});

PermissionRequestDialog.displayName = "PermissionRequestDialog";

export default PermissionRequestDialog;
